import React from "react";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

const Error = props => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={props.noDecoration ? "" : "mainContent"}
      style={{
        height: props.height ? props.height : "initial",
        minHeight: "initial"
      }}
    >
      <Grid item>
        <Box className="text-54">{props.error}</Box>
      </Grid>
    </Grid>
  );
};

export default Error;
